<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 449.4 209" style="enable-background:new 0 0 449.4 209;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t8_1_" y="62.9" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_2_">
        <use xlink:href="#t8_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="t8_3_" d="M0,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6C0.9,141.8,0,139.5,0,137.1
              z"/>
          </defs>
          <clipPath id="t8_4_">
            <use xlink:href="#t8_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M0,146.1V62.9h83.2v83.2H0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_5_" x="366.2" y="62.9" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_6_">
        <use xlink:href="#t8_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="t8_7_" d="M366.2,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6
              C367.2,141.8,366.2,139.5,366.2,137.1z"/>
          </defs>
          <clipPath id="t8_8_">
            <use xlink:href="#t8_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M366.2,146.1V62.9h83.2v83.2H366.2z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_9_" x="302.4" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_10_">
        <use xlink:href="#t8_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="t8_11_" d="M302.4,74.2V9c0-2.4,1-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2
              c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-1-6.4-2.6S302.4,76.6,302.4,74.2z"/>
          </defs>
          <clipPath id="t8_12_">
            <use xlink:href="#t8_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M302.4,83.2V0h83.2v83.2H302.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_13_" x="180.4" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_14_">
        <use xlink:href="#t8_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="t8_15_" d="M180.4,74.2V9c0-2.4,0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2
              c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-1-6.4-2.6S180.4,76.6,180.4,74.2z"/>
          </defs>
          <clipPath id="t8_16_">
            <use xlink:href="#t8_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M180.4,83.2V0h83.2v83.2H180.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_17_" x="66" y="62.9" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_18_">
        <use xlink:href="#t8_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="t8_19_" d="M66,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2
              c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H75c-2.4,0-4.7-0.9-6.4-2.6S66,139.5,66,137.1z"/>
          </defs>
          <clipPath id="t8_20_">
            <use xlink:href="#t8_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M66,146.1V62.9h83.2v83.2H66z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_21_" x="62.9" y="0" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_22_">
        <use xlink:href="#t8_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <path id="t8_23_" d="M71.9,0h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H71.9
              c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,0.9-4.7,2.6-6.4S69.5,0,71.9,0z"/>
          </defs>
          <clipPath id="t8_24_">
            <use xlink:href="#t8_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st2" d="M62.9,0h83.2v83.2H62.9V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_25_" x="62.9" y="125.8" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_26_">
        <use xlink:href="#t8_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st13">
        <g>
          <defs>
            <path id="t8_27_" d="M71.9,125.8h65.2c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4V200c0,2.4-0.9,4.7-2.6,6.4
              s-4,2.6-6.4,2.6H71.9c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-65.2c0-2.4,0.9-4.7,2.6-6.4C67.2,126.8,69.5,125.8,71.9,125.8z"/>
          </defs>
          <clipPath id="t8_28_">
            <use xlink:href="#t8_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st14">
            <path class="st2" d="M62.9,125.8h83.2V209H62.9V125.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_29_" x="180.4" y="125.8" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_30_">
        <use xlink:href="#t8_29_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st15">
        <g>
          <defs>
            <path id="t8_31_" d="M189.4,125.8h65.2c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4V200c0,2.4-0.9,4.7-2.6,6.4
              s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-65.2c0-2.4,0.9-4.7,2.6-6.4C184.8,126.8,187,125.8,189.4,125.8z"
              />
          </defs>
          <clipPath id="t8_32_">
            <use xlink:href="#t8_31_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <path class="st2" d="M180.4,125.8h83.2V209h-83.2V125.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_33_" x="302.4" y="125.8" width="83.2" height="83.2"/>
      </defs>
      <clipPath id="t8_34_">
        <use xlink:href="#t8_33_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st17">
        <g>
          <defs>
            <path id="t8_35_" d="M302.4,200v-65.2c0-2.4,1-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4V200
              c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6S302.4,202.4,302.4,200z"/>
          </defs>
          <clipPath id="t8_36_">
            <use xlink:href="#t8_35_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st18">
            <path class="st2" d="M302.4,209v-83.2h83.2V209H302.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_37_" x="14.7" y="14.7" width="418.9" height="179.6"/>
      </defs>
      <clipPath id="t8_38_">
        <use xlink:href="#t8_37_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st19">
        <g>
          <defs>
            <path id="t8_39_" d="M37.7,14.7h372.8c12.7,0,23,10.3,23,23v133.6c0,12.7-10.3,23-23,23H37.7c-12.7,0-23-10.3-23-23V37.7
              C14.7,25,25,14.7,37.7,14.7z"/>
          </defs>
          <clipPath id="t8_40_">
            <use xlink:href="#t8_39_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st20">
            <path class="st21" d="M14.7,14.7h418.9v179.6H14.7V14.7z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t8_41_" x="155.7" y="36.2" width="136.7" height="136.7"/>
      </defs>
      <clipPath id="t8_42_">
        <use xlink:href="#t8_41_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st22">
        <g>
          <defs>
            <circle id="t8_43_" cx="224.1" cy="104.5" r="68.3"/>
          </defs>
          <clipPath id="t8_44_">
            <use xlink:href="#t8_43_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st23">
            <path class="st2" d="M155.7,36.2h136.7v136.7H155.7V36.2z"/>
          </g>
        </g>
      </g>
    </g>
    </svg>
</template>
<script>
export default {
  name: 't8'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .st0{clip-path:url(#t8_2_);}
  .st1{clip-path:url(#t8_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t8_6_);}
  .st4{clip-path:url(#t8_8_);}
  .st5{clip-path:url(#t8_10_);}
  .st6{clip-path:url(#t8_12_);}
  .st7{clip-path:url(#t8_14_);}
  .st8{clip-path:url(#t8_16_);}
  .st9{clip-path:url(#t8_18_);}
  .st10{clip-path:url(#t8_20_);}
  .st11{clip-path:url(#t8_22_);}
  .st12{clip-path:url(#t8_24_);}
  .st13{clip-path:url(#t8_26_);}
  .st14{clip-path:url(#t8_28_);}
  .st15{clip-path:url(#t8_30_);}
  .st16{clip-path:url(#t8_32_);}
  .st17{clip-path:url(#t8_34_);}
  .st18{clip-path:url(#t8_36_);}
  .st19{clip-path:url(#t8_38_);}
  .st20{clip-path:url(#t8_40_);}
  .st21{fill:#85B0F9;}
  .st22{clip-path:url(#t8_42_);}
  .st23{clip-path:url(#t8_44_);}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t9.vue